import { render, staticRenderFns } from "./TeamHero.vue?vue&type=template&id=3afa6474&scoped=true&"
import script from "./TeamHero.vue?vue&type=script&lang=js&"
export * from "./TeamHero.vue?vue&type=script&lang=js&"
import style0 from "./TeamHero.vue?vue&type=style&index=0&id=3afa6474&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa6474",
  null
  
)

export default component.exports